import { Modal } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {FETCH_LATEST_VERSION} from "../../redux/actions";

const LatestVersionModal = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const { latestVersion, loading, error } = useSelector((state) => state.latestVersion);

    const [isModalOpen, setIsModalOpen] = useState(true);

    const handleOk = () => {
        navigate('/setting')
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    useEffect(() => {
        dispatch({ type: FETCH_LATEST_VERSION });
    }, []);



    return (
        <></>
       /* <>
            {/!*
            TODO:// Remove not operand
            *!/}
            {!latestVersion?.lts_version && (
                <Modal
                    title={
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <ExclamationCircleOutlined style={{ color: "#faad14", fontSize: "18px" }} />
                            <span>Plugin Update</span>
                        </div>
                    }
                    open={isModalOpen}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    okText="Update"
                >
                    <div>
                        <span style={{ fontSize: "14px" }}>{latestVersion.update_program_text}</span>
                    </div>
                </Modal>
            )}
        </>*/
    );
};

export default LatestVersionModal;
